import { Box } from '@mui/material';
import { LoginLogo } from './LoginLogo';
import { LoginTitle } from './LoginTitle';
import { LoginFormFields } from './LoginFormFields';
import { PasswordRecoveryDialog } from './PasswordRecoveryDialog';

export const LoginFormContent = (props) => (
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: { xs: '40px 20px', md: '60px' },
      backgroundColor: '#ffffff',
    }}
  >
    <Box
      sx={{
        width: '100%',
        maxWidth: '400px',
      }}
    >
      <LoginLogo src={props.images.logo} />
      <LoginTitle />
      <LoginFormFields {...props} />
      <PasswordRecoveryDialog
        open={props.recoveryDialogOpen}
        onClose={props.closeRecoveryDialog}
        onSubmit={props.handlePasswordRecovery}
        isLoading={props.isRecoveringPassword}
        successMessage={props.recoveryMessage}
        errorMessage={props.recoveryError}
        defaultEmail={props.recoveryDefaultEmail}
      />
    </Box>
  </Box>
);
